import * as R from 'ramda';

export default function uniqueAssetTypePresetsDirective(
  $q,
  assetDataService
) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link,
  };

  function link(scope, el, attrs, ctrl) {
    const customerAssetId = attrs.customerAssetId || -1;

    ctrl.$asyncValidators.uniqueAssetTypePresets = (modelValue) => {
      if (ctrl.$isEmpty(modelValue)) {
        // Consider empty model valid. This is probably the view's initial load.
        return $q.resolve();
      }

      const prefix = _getName(modelValue);

      if (!prefix) {
        // Nothing to check, move along... move along...
        return $q.resolve();
      }

      const def = $q.defer();

      // We have a prefix, so see if it exists
      assetDataService.checkTypePresetsForDuplicates(customerAssetId, prefix).then((response) => {
        const isExists = response.data.result;
        if (!isExists) {
          def.resolve();
        } else {
          def.reject();
        }
      }).catch(() => def.reject());

      return def.promise;
    };
  }

  function _getName(modelValue) {
    switch (R.type(modelValue)) {
      case 'Object':
        return modelValue.name;
      default:
        // Assume modelValue is a string
        return modelValue;
    }
  }
}

export const name = 'uniqueAssetTypePresets';

uniqueAssetTypePresetsDirective.$inject = [
  '$q',
  'assetDataService'
];
